import React from 'react';
import { withRouter } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons/faCommentDots';
import PreCommentsDialog from './PreCommentsDialog';

export default withRouter(function PreCommentsIcon(props){
    const { project,preEForm} = props;
    function commentsConfirm(project){
        confirmAlert({
            customUI: ({onClose}) => {
                return(
                    <PreCommentsDialog onClose={onClose} projectId={project.id} project={project} formId={preEForm.id}/>
                );
            }
        });
    }
    return(
        <FontAwesomeIcon id={"cmticon"}
                         icon={faCommentDots} pull={"right"} size ="lg" style={{cursor:'pointer'}}
                         onClick={() =>  commentsConfirm(project)}>Comment</FontAwesomeIcon>


    )
})
